import { ActionButton } from '@/types';
import { t } from 'i18next';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { iconPencil, iconTrashCan } from '@/components/icons';
import { baseStyles, buttonStyles } from '@/styles';

@customElement('fg-collapsible-icon-button')
export class FgCollapsibleIconButton extends LitElement {
  @property({ type: String })
  actionButton!: ActionButton;

  @property({ type: String })
  buttonTitle!: string;

  @property({ type: Boolean })
  asDiv = false;

  updateComponent() {
    this.dispatchEvent(
      new CustomEvent(`action-${this.actionButton}`, {
        composed: true,
      }),
    );
  }

  render() {
    if (!this.actionButton) return nothing;

    const buttonTitleAction =
      this.actionButton === ActionButton.EDIT
        ? t('actions.edit')
        : t('actions.delete');

    if (this.asDiv) {
      return html`
        <div class="icon ${this.actionButton}">
          ${this.actionButton === ActionButton.EDIT ? iconPencil : iconTrashCan}
        </div>
      `;
    }

    return html`
      <button
        type="button"
        class="icon ${this.actionButton}"
        title="${buttonTitleAction} ${this.buttonTitle}"
        @click=${() => this.updateComponent()}
      >
        ${this.actionButton === ActionButton.EDIT ? iconPencil : iconTrashCan}
      </button>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      .icon {
        width: 24px;
        height: 24px;
        display: inline-grid;
        place-items: center;
        flex-shrink: 0;
      }

      .icon.edit,
      .icon.delete {
        background-color: var(
          --fg-primary--light,
          var(--fg-fallback-primary--light)
        );
        border-radius: 50%;
        color: var(--fg-primary, var(--fg-fallback-primary));
      }

      .icon.delete {
        color: var(--fg-error, var(--fg-fallback-error));
      }

      .icon.edit svg,
      .icon.delete svg {
        max-height: 12px;
        max-width: 12px;
      }
    `,
  ];
}
